import type { ReactNode } from 'react'

export default function Layout({ children }: { children: ReactNode }) {
  return (
    <div className="flex flex-col h-svh overflow-hidden bg-bg max-w-lg mx-auto">
      {children}
    </div>
  )
}
